// project import
import dashboard from './dashboard';
import pages from './page';
import utilities from './utilities';
import payments from './payments';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, payments, pages, utilities]
};

export default menuItems;
